<footer class="border-t border-mist bg-warm-surface font-body">
	<div class="container mx-auto px-4 py-12">
		<div class="grid grid-cols-1 gap-8 md:grid-cols-4">

			<!-- Brand -->
			<div class="space-y-3">
				<h3 class="font-display text-base font-titre text-ink">Fiche Séquence</h3>
				<p class="text-sm leading-relaxed text-ash">
					Outils pédagogiques pour les enseignants du primaire, de la Maternelle au CM2.
				</p>
				<p class="text-xs leading-relaxed text-ash-light">
					Générations propulsées par une IA française (Mistral AI) — données traitées en Europe.
				</p>
			</div>

			<!-- Liens utiles -->
			<div class="space-y-3">
				<h3 class="text-xs font-semibold uppercase tracking-wider text-ash-light">Outils</h3>
				<nav class="flex flex-col space-y-1.5">
					<a href="/generateur" class="text-sm text-ash transition-colors hover:text-ink">Fiches séquences</a>
					<a href="/cahier-journal" class="text-sm text-ash transition-colors hover:text-ink">Cahier journal</a>
					<a href="/generateur-bulletin" class="text-sm text-ash transition-colors hover:text-ink">Générateur de bulletin</a>
					<a href="/generateur-progression-annuelle" class="text-sm text-ash transition-colors hover:text-ink">Progressions annuelles</a>
					<a href="/generateur-evaluation" class="text-sm text-ash transition-colors hover:text-ink">Évaluations</a>
					<a href="/fiches-exercices" class="text-sm text-ash transition-colors hover:text-ink">Fiches d'exercices</a>
					<a href="/guide/plan-de-classe" class="text-sm text-ash transition-colors hover:text-ink">Plan de classe</a>
					<a href="/sonometre" class="text-sm text-ash transition-colors hover:text-ink">Sonomètre</a>
					<a href="/issr" class="text-sm text-ash transition-colors hover:text-ink">Calculateur ISSR</a>
					<a href="/pricing" class="text-sm text-ash transition-colors hover:text-ink">Tarifs</a>
					<a href="/contact" class="text-sm text-ash transition-colors hover:text-ink">Contact</a>
				</nav>
			</div>

			<!-- Cycles -->
			<div class="space-y-3">
				<h3 class="text-xs font-semibold uppercase tracking-wider text-ash-light">Cycles</h3>
				<nav class="flex flex-col space-y-1.5">
					<a href="/cycle-1-maternelle" class="text-sm text-ash transition-colors hover:text-ink">Cycle 1 – Maternelle</a>
					<a href="/cycle-2-cp-ce1-ce2" class="text-sm text-ash transition-colors hover:text-ink">Cycle 2 – CP/CE1/CE2</a>
					<a href="/cycle-3-cm1-cm2" class="text-sm text-ash transition-colors hover:text-ink">Cycle 3 – CM1/CM2</a>
					<a href="/guide" class="text-sm text-ash transition-colors hover:text-ink">Tous les guides</a>
				</nav>
			</div>

			<!-- Légal -->
			<div class="space-y-3">
				<h3 class="text-xs font-semibold uppercase tracking-wider text-ash-light">Légal</h3>
				<nav class="flex flex-col space-y-1.5">
					<a href="/legal" class="text-sm text-ash transition-colors hover:text-ink">Mentions légales</a>
					<a href="/legal#privacy" class="text-sm text-ash transition-colors hover:text-ink">Politique de confidentialité</a>
					<a href="/legal#cgu" class="text-sm text-ash transition-colors hover:text-ink">CGU</a>
				</nav>
			</div>
		</div>

		<div class="mt-10 border-t border-mist pt-6 text-center">
			<p class="text-sm text-ash-light">
				© {new Date().getFullYear()} Fiche Séquence. Tous droits réservés.
			</p>
		</div>
	</div>
</footer>
